import React, { useEffect, useState } from "react";
import { OPTIONS_DATA_MAPPER } from "../../utils";
import AddToolTip from "../AddToolTip";
import { useDeepEffect } from "../../abstracts";
const RollOverPlanCard = (props) => {
  const {
    plans,
    checked,
    fields,
    setFieldValue,
    handleChange,
    values,
    selectedPlan,
    setSelectedPlan,
    setValues,
    removeRadioButton,
  } = props;
  useEffect(() => {
    //to default select the single plan when only one plan is present
    if (plans.length === 0 || plans.length > 1) return;
    setSelectedPlan(plans[0].planId);
  }, [plans]);
  const clearValues = (id) => {
    setValues({
      //...values,
      planName: "",
      rolloverAmount: "",
      companyName: "",
      trusteeOrCustodianName: "",
      custodianBankName: "",
      custodianAccountNumber: "",
    });
    setSelectedPlan(id);
  };

  return (
    <div>
      {plans.map((data, index) => {
        const sourceNames = data.source
          ? data.source.map((item, idx) =>
              idx != data.source.length - 1
                ? item.sourceName + ","
                : item.sourceName
            )
          : "NA";
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              padding: "15px",
              border:
                index == selectedPlan
                  ? "1px solid #307BF6"
                  : "1px solid #BDBDBD",
              backgroundColor:
                index == selectedPlan ? "rgba(48, 123, 246, 0.1)" : "white",
              borderRadius: "5px",
              marginBottom: "25px",
              cursor: "pointer",
            }}
            onClick={() => clearValues(data.planId)}
          >
            {!removeRadioButton ? (
              <input
                style={{ margin: "0px 33px 0px 18px" }}
                defaultChecked={data.planId === selectedPlan}
                checked={data.planId === selectedPlan}
                type="radio"
                //value={values[fields.planName]}
                // onChange={(value) => {
                //   setFieldValue(fields.planName, value);
                // }}
                name="plan"
                onClick={() => clearValues(data.planId)}
              />
            ) : (
              <></>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                paddingLeft: "5px",
                paddingRight: "35px",
                width: "35%",
              }}
            >
              <p
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "#3B3B3B",
                  marginTop: "6px",
                  marginBottom: "3px",
                  padding: "0px",
                }}
              >
                {data.planName}
              </p>
              <p
                style={{
                  fontWeight: "400",
                  fontSize: "16px",
                  color: "#777777",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                {data.rkPlanNumber}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                borderRight: " 0.5px solid #BDBDBD",
                borderLeft: " 0.5px solid #BDBDBD",
                padding: "0px 35px",
                width: "25%",
              }}
            >
              <p
                style={{
                  fontWeight: "400",
                  fontSize: "16px",
                  color: "#777777",
                  padding: "0px",
                  marginBottom: "3px",
                }}
              >
                Type
              </p>
              <p
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "#000000",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                {data.planType}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingLeft: "35px",
                alignItems: "flex-start",
                width: "45%",
              }}
            >
              <p
                style={{
                  fontWeight: "400",
                  fontSize: "16px",
                  color: "#777777",
                  padding: "0px",
                  marginBottom: "3px",
                }}
              >
                Available source(s)
              </p>
              <p
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "#000000",
                  padding: "0px",
                  margin: "0px",
                  maxWidth: "100%",
                }}
              >
                {/* {data.availableSource} */}
                <AddToolTip name={sourceNames}>{sourceNames}</AddToolTip>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RollOverPlanCard;
